import React from "react";
import { useState } from "react";
import { Checkbox, Text } from "@mantine/core";

export default function TermsCheckbox({ onChange }) {
  const [checked, setChecked] = useState(false);

  const handleChange = (value) => {
    setChecked(value);
    onChange?.(value);
  };

  return (
    <Checkbox
      checked={checked}
      onChange={(e) => handleChange(e.currentTarget.checked)}
      label={
        <Text size="sm">
          I agree to the{" "}
          <a
            href="https://www.playsafelysports.com/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
        </Text>
      }
      required
      mt="md"
    />
  );
}
